import { useEffect } from 'react';
import { IAuthStore } from 'src/store/auth/auth.store';
import useStore from './useStore';
import { Modal } from 'antd';

export const useShowResetTimeoutConfirmation = (actionTime: number | string = 10) => {
	const authStore: IAuthStore = useStore('authStore');
	const [modal, contextHolder] = Modal.useModal();

	useEffect(() => {
		if (authStore.isSessionExpired) {
			const secondsToGo = Number(actionTime);
			let hideTimer: number | null = null;

			const instance = modal.confirm({
				title: 'Session Expiring',
				content: 'Your session is about to expire. Do you need more time ?',
				onOk: () => {
					authStore.resetTimeout();
					hideTimer && clearTimeout(hideTimer);
				},
				onCancel: () => authStore.logout(),
				okText: 'Yes',
				cancelText: 'No',
				maskClosable: false,
				centered: true
			});

			hideTimer = setTimeout(() => {
				instance.destroy();
				authStore.logout();
			}, secondsToGo * 1000) as unknown as number;
		}
	}, [authStore.isSessionExpired]);

	return contextHolder;
};
